import React from 'react';

// PDFs live in public/legal/Hustli_Legal_Package/ (served at /legal/Hustli_Legal_Package/...)
const LEGAL_BASE = '/legal/Hustli_Legal_Package';
const LEGAL_LINKS = [
  { href: `${LEGAL_BASE}/Hustli_Terms_with_LLC.pdf`, label: 'Terms of Service' },
  { href: `${LEGAL_BASE}/Hustli_Privacy_with_LLC.pdf`, label: 'Privacy Policy' },
  { href: `${LEGAL_BASE}/Hustli_COPPA_with_LLC.pdf`, label: 'COPPA' },
  { href: `${LEGAL_BASE}/Hustli_Acceptable_Use_with_LLC.pdf`, label: 'Acceptable Use' },
  { href: `${LEGAL_BASE}/Hustli_Refund_with_LLC.pdf`, label: 'Refund Policy' },
  { href: `${LEGAL_BASE}/Hustli_Cookie_with_LLC.pdf`, label: 'Cookie Policy' },
  { href: `${LEGAL_BASE}/Hustli_SLA_with_LLC.pdf`, label: 'SLA' },
  { href: `${LEGAL_BASE}/Hustli_Safety_AI_Disclaimer_with_LLC.pdf`, label: 'Safety & AI Disclaimer' },
] as const;

interface FooterProps {
  /** Optional extra class (e.g. md:hidden for mobile-only on dashboard) */
  className?: string;
  /** Visual style variant */
  variant?: 'default' | 'landing';
}

export const Footer: React.FC<FooterProps> = ({ className = '', variant = 'default' }) => {
  const year = new Date().getFullYear();

  const base =
    variant === 'landing'
      ? 'bg-primary text-white border-t border-white/15'
      : 'border-t border-stone-200 bg-stone-50/80 text-stone-600';

  const linkClass =
    variant === 'landing'
      ? 'text-white/90 hover:text-white hover:underline focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-primary rounded'
      : 'text-primary hover:underline focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-1 rounded';

  return (
    <footer
      className={`${base} py-6 px-4 text-sm ${className}`}
      role="contentinfo"
    >
      <div className="max-w-7xl mx-auto flex flex-col sm:flex-row gap-4 sm:gap-6 items-center sm:items-end justify-between">
        <div className="text-center sm:text-left">
          <p className={variant === 'landing' ? 'text-white/80' : 'text-stone-600'}>
            © {year} HUSTLi LLC. All rights reserved.
          </p>
        </div>

        <div className="flex flex-wrap justify-center sm:justify-end gap-x-4 gap-y-2">
          {LEGAL_LINKS.map(({ href, label }) => (
            <a
              key={href}
              href={href}
              target="_blank"
              rel="noopener noreferrer"
              className={linkClass}
            >
              {label}
            </a>
          ))}
        </div>
      </div>
    </footer>
  );
};

export default Footer;
